import { defineMessages } from 'react-intl-next';

const messages: {
	portals: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	portals: {
		id: 'company-hub.hub-app-shell.navbar.nav-links.portals.non-final',
		defaultMessage: 'Portals',
		description: 'Navigation link label for the portals dropdown',
	},
});

export default messages;
